import { connect } from "react-redux";
import { Dispatch } from "redux";
import Text from "src/components/text/Text";
import localeService from "src/dataServices/LocaleService";
import { IApplicationState } from "src/state";
import { accountOfferRequest } from "src/state/offers/accountguard/actions";
import { IClaimOfferRequestState } from "src/state/offers/accountguard/types";

interface IAccountGuardFreeSecurityProps {
  accountGuard: IClaimOfferRequestState;
  accountOfferRequest: typeof accountOfferRequest;
}

const AccountGuardFreeSecurityAssessmentBanner = (props: IAccountGuardFreeSecurityProps) => {
  const isClaimDisabled = props.accountGuard.claimStatus || props.accountGuard.sentSuccessfully || props.accountGuard.isSending;
  return (
    <section>
      <div className="container-style align-items-center justify-content-center ml-5 mr-5 mt-2">
        <div className="text-box-style d-flex align-items-center justify-content-center">
          <h2 id="title" className="text-style h3 mb-0 text-center">
            <Text category="AccountGuardV2" id="AccountGuardEnrollTitle" />
          </h2>
        </div>
        <div className="text-box-style d-flex align-items-center justify-content-center">          
          <p className="align-items-center justify-content-center text-center">
            <Text category="AccountGuardV2" id="AccountGuardEnrollParagraph" />
          </p>
        </div>
      </div>
      <div className="card d-block mx-ng mx-md-0 mt-5 mb-5">
        <div id="account-guard-free-security-assessment-section" className="row no-gutters material-surface ml-5 mr-5">
          <div className="col-md-6">
            <picture>
              <source
                srcSet={`${process.env.REACT_APP_HUB_IMAGES_CDN_URL}/AccountGuard/AcctGrd-Banner1-1920.jpg`}
                media="(min-width: 1400px)"
              />
              <source
                srcSet={`${process.env.REACT_APP_HUB_IMAGES_CDN_URL}/AccountGuard/AcctGrd-Banner1-1400.jpg`}
                media="(min-width: 1084px)"
              />
              <source
                srcSet={`${process.env.REACT_APP_HUB_IMAGES_CDN_URL}/AccountGuard/AcctGrd-Banner1-1084.jpg`}
                media="(min-width: 860px)"
              />
              <source
                srcSet={`${process.env.REACT_APP_HUB_IMAGES_CDN_URL}/AccountGuard/AcctGrd-Banner1-860.jpg`}
                media="(min-width: 540px)"
              />
              <img
                src={`${process.env.REACT_APP_HUB_IMAGES_CDN_URL}/AccountGuard/AcctGrd-Banner1-540.jpg`}
                className="card-img img-object-cover"
                alt={localeService.getText("AccountGuardV2", "FreeSecurityAssessmentPlaceholder")}
              />
            </picture>
          </div>
          <div className="d-flex col-md">
            <div className="card-body align-self-center p-4 p-md-5">
              <h2 id="account-guard-free-security-assessment-title" className="text-style h3">
                <Text category="AccountGuardV2" id="ActivateAccountGuardTitle" />
              </h2>
              <div id="account-guard-free-security-assessment-description" className="Detail-text mb-3 mt-2">
                <p>
                  <Text category="AccountGuardV2" id="ActivateAccountGuardDescription" />
                </p>
              </div>
              <div className="info-card">
                <div className="step-card-button mt-4">
                  <a
                    id="account-guard-free-security-assessment-button"
                    href="src/components/offers/shared"
                    className={(isClaimDisabled ? 'cta-disabled-style ' : 'cta-enabled-style ') + 'cta'}
                    aria-disabled={isClaimDisabled}
                    onClick={(e) => {
                      e.preventDefault();
                      if (!isClaimDisabled) {
                        props.accountOfferRequest();
                      }
                    }}
                    aria-label={localeService.getText("AccountGuardV2", "ClaimNowText")}
                  >
                    {localeService.getText("AccountGuardV2", "ClaimNowText")}
                    <span className="glyph" aria-hidden="true"></span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="text-box-style d-flex align-items-center justify-content-center ml-5 mr-5 mb-5">          
          <p className="align-items-center text-center">
            <Text category="AccountGuardV2" id="AccountGuardEnrollDescription" />
          </p>
        </div>
    </section>
  );
};

const mapStateToProps = ({ offers }: IApplicationState) => ({
  accountGuard: offers.accountGuardOffer
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  accountOfferRequest: () => dispatch(accountOfferRequest())
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountGuardFreeSecurityAssessmentBanner);
